// src/utilities/document-icon-utils.ts
function getIconProperties(contentType) {
  switch (contentType) {
    case "image/bmp":
    case "image/x-ms-bmp":
    case "image/x-windows-bmp":
    case "image/gif":
    case "image/jpeg":
    case "image/pjpeg":
    case "image/png":
    case "image/tiff":
    case "image/x-tiff":
      return { foreground: "secondary", name: "file-image", library: "solid" };
    case "application/msword":
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      return { foreground: "primary", name: "file-word", library: "solid" };
    case "application/pdf":
      return { foreground: "danger", name: "file-pdf", library: "solid" };
    case "application/vnd.ms-excel":
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      return { foreground: "success", name: "file-excel", library: "solid" };
    case "text/csv":
      return { name: "file-csv", library: "solid" };
    default:
      return { foreground: "neutral", name: "file-lines", library: "solid" };
  }
}

export {
  getIconProperties
};
